// Interaction pill with a styled keycap, e.g.  [ E ]  Pick up Amber Crystal.
// `showPrompt({ key, text })` updates in place; `hidePrompt()` fades it out.

let element = null;

function build() {
  const el = document.createElement('div');
  el.className = 'prompt hidden';
  el.innerHTML = `
    <kbd class="prompt-key"></kbd>
    <span class="prompt-text"></span>
  `;
  document.body.appendChild(el);
  return el;
}

export function initPromptUI() {
  element = build();
}

export function showPrompt({ key = 'E', text }) {
  if (!element) initPromptUI();
  element.querySelector('.prompt-key').textContent = key;
  element.querySelector('.prompt-text').textContent = text;
  element.classList.remove('hidden');
}

export function hidePrompt() {
  if (element) element.classList.add('hidden');
}
